import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { CadenceTemplate, CadenceTemplateVariant, PlaybookStore, renamePlaybookTemplateVariant, toggleTemplateStatus, toggleTemplateVariantStatus } from '../PlaybookStore';
import {
    DataGridPro,
    GridColumns,
    GridRowModelUpdate,
    useGridApiContext,
    GridRowParams,
} from '@mui/x-data-grid-pro';
import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, FormGroup, FormHelperText, Grid } from '@mui/material';
import PencilOutline from 'mdi-material-ui/PencilOutline'
import IconButton from '@mui/material/IconButton'
import CustomChip from 'src/materio/@core/components/mui/chip'
import SourceIcon from '@mui/icons-material/Source';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NameDialog from '../NameDialog';
import { client } from '../../../utils/axios-client';

type CellType = {
    row: CadenceTemplateVariant
}

const defaultColumns = [
    {
        flex: 0.65,
        field: 'name',
        minWidth: 240,
        headerName: 'Variant Name',
        renderCell: ({ row }: CellType) => <Typography>{row.name}</Typography>
    }, {
        flex: 0.25,
        field: 'templateType',
        minWidth: 240,
        headerName: 'Template Type',
        renderCell: ({ row }: CellType) => <Typography>{row.templateType}</Typography>
    }
]

type Props = {
    disabled: boolean,
    filter: string,
    parentRow: CadenceTemplate,
    onEditVariant: (row: CadenceTemplateVariant) => void,
    onShowFilters: (row: CadenceTemplateVariant) => void
}

const TemaplateWithVariantRow = ({ parentRow, onEditVariant, filter, onShowFilters, disabled }: Props) => {
    const [rows, setRows] = useState(parentRow.variants);
    const [renameDialogOpen, setRenameDialogOpen] = React.useState<boolean>(false)
    const apiRef = useGridApiContext();
    const selectedTemplateVariant = PlaybookStore.useState(s => s.selectedTemplateVariant);
    console.log('dis', disabled)
    React.useEffect(() => {
        setRows(parentRow.variants);
    }, [parentRow])

    const onSubmit = (data: GridRowModelUpdate) => {
        apiRef.current.updateRows([data]);
        apiRef.current.toggleDetailPanel(parentRow.id);
    };

    const handleStartRename = (row: CadenceTemplateVariant) => {
        PlaybookStore.update((s, o) => {
            s.selectedTemplateVariant = { ...row, templateBody: o.selectedTemplate?.templateBody ?? '' };
        })

        setRenameDialogOpen(true);
    }

    const onLibrarySelect = async (id: string) => {
        const response = await client.get('/api/playbooks/templates', { params: { id: id } });

        onEditVariant(response.data);



        /*setSelectedRecord(response.data);*/
    }

    const columns = [
        ...defaultColumns,        
        {
            flex: 0.15,
            minWidth: 115,
            sortable: false,
            field: 'actions',
            headerName: 'Actions',
            renderCell: ({ row }: CellType) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={() => handleStartRename(row)} title="Rename Template" disabled={disabled}>
                        <PencilOutline fontSize='small' />
                    </IconButton>
                    <IconButton onClick={() => onShowFilters(row)} title="Filters" disabled={disabled}>
                        <FilterAltIcon fontSize='small' />
                    </IconButton>
                    <IconButton onClick={() => onLibrarySelect(row.id)} title="Edit Content" disabled={disabled}>
                        <SourceIcon fontSize='small' />
                    </IconButton>
                </Box>
            )
        }
    ]

    return (
        <Stack
            sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
            direction="column"
        >
            <Paper sx={{ flex: 1, mx: 'auto', width: '95%', p: 0 }}>
                <Stack
                    component="form"
                    justifyContent="space-between"
                    sx={{ height: 1 }}
                >
                    <Grid container>
                        <Grid item xs={12}>
                            <DataGridPro
                                autoHeight
                                columns={columns}
                                rows={rows}
                                disableSelectionOnClick
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Paper>

            {selectedTemplateVariant && <NameDialog open={renameDialogOpen} onClose={() => setRenameDialogOpen(false)} onSubmit={(data: CadenceTemplateVariant) => renamePlaybookTemplateVariant(data, filter)} title="Rename Template Variant" subTitle="Please enter a name for the template variant" fieldLabel="Playbook Temaplte Variant" confirmButtonLabel="Rename" record={selectedTemplateVariant} />}
        </Stack>
    );
}

export { TemaplateWithVariantRow }
export default TemaplateWithVariantRow;